(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-private-order"]) return;
  try {
    
  if (!customElements.get('nt-private-order')) {
    customElements.define('nt-private-order', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.inputs = Array.from(this.querySelectorAll('[data-variant-id]'));
        this.button = this.querySelector('button[type="submit"]');
        this.buttonLabel = this.button.textContent;
        this.message = this.querySelector('[data-message]');
        this.reviewCart = this.querySelector('[data-review-cart]');
        this.total = this.querySelector('[data-total]');
        this.money = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code' });
        this.form.addEventListener('input', () => this.updateTotal());
        this.form.addEventListener('submit', event => this.submit(event));
        this.updateTotal();
      }

      quantity(input) {
        const quantity = input.value === '' ? 0 : Number(input.value);
        return Number.isSafeInteger(quantity) && quantity >= 0 ? quantity : NaN;
      }

      updateTotal() {
        let total = 0;
        if (!this.uncertain) this.message.hidden = true;
        for (const input of this.inputs) {
          input.setCustomValidity('');
          const quantity = this.quantity(input);
          if (!input.disabled && Number.isFinite(quantity)) total += quantity * Number(input.dataset.price);
        }
        this.total.textContent = this.money.format(total / 100).replace(/\u00a0/g, ' ');
        this.button.disabled = Boolean(this.submitting || this.uncertain);
      }

      async submit(event) {
        event.preventDefault();
        if (this.submitting || this.uncertain) return;
        this.message.hidden = true;
        const items = [];
        for (const input of this.inputs) {
          if (input.disabled) continue;
          const quantity = this.quantity(input);
          const minimum = Number(input.dataset.minimum) || 1;
          const increment = Number(input.dataset.increment) || 1;
          if (!Number.isFinite(quantity) || (quantity > 0 && (quantity < minimum || quantity % increment !== 0))) {
            input.setCustomValidity(this.dataset.invalid);
            input.reportValidity();
            return;
          }
          if (quantity > 0) items.push({ id: input.dataset.variantId, quantity });
        }
        if (!this.form.reportValidity()) return;
        if (!items.length) {
          this.message.textContent = this.dataset.empty;
          this.message.hidden = false;
          return;
        }
        this.submitting = true;
        this.button.disabled = true;
        this.button.textContent = this.dataset.adding;
        this.form.setAttribute('aria-busy', 'true');
        for (const input of this.inputs) input.readOnly = true;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error(this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch {
          this.uncertain = true;
          this.message.textContent = this.dataset.error;
          this.message.hidden = false;
          this.reviewCart.hidden = false;
          this.button.textContent = this.buttonLabel;
          this.form.removeAttribute('aria-busy');
          this.reviewCart.focus();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
